import React from 'react';
import { withWebView } from '../hoc/withWebView';
import FaqContent from '../components/FaqContent';

export default withWebView(FaqContent, 'faq'); 